<template>
<div class="thankyou_page" id="flight-result-wrapper">
    <div class="generate-ex-btn" @click="toggleJsonExcelModal" v-if="lsRoutesTableFields.length>0">
        <img src="@imgPath/img/svg/icons/excle-icon.svg" alt />
    </div>

    <CDataTable :fields="lsRoutesTableFields" :items="getTableItems()">
        <!-- <template #key="{item,index}">
           <td>
 <div v-for="(k,index) in item.key" :key="index">
             {{k}}
           </div>
           </td>
         </template>
          <template #value="{item,index}">
           <td>
 <div v-for="(value,index) in item.value" :key="index">
             {{value}}
           </div>
           </td>
         </template> -->
    </CDataTable>
        <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
<!-- <div>{{tableData}}</div>
<div>{{tableHeader}}</div> -->

    <div class="tq-wrapper">
        <section class="main">
            <div class="row">
                <cSearch v-if="isShowState" :searchObject="search" v-on:send="navToResultPage" />
                <div class="col-md-12 action-img"><br /><br /><br /></div>
                <form style="
    padding-left: 225px;
">
                    <date-picker mode="range" :input-debounce="500" v-model="range" :columns="$screens({ default: 1, lg: 2 })">
                        <div class="date">
                            <label class="typo__label depart">Depart</label><label class="typo__label return">Return</label>
                            <div class="datepicker__wrapper">
                                <!---->
                                <div class="datepicker__dummy-wrapper">
                                    <div data-qa="datepickerInput" tabindex="0" class="datepicker__input" hide-datepicker="function () { [native code] }">
                                        Mon, Apr 06
                                    </div>
                                    <div data-qa="datepickerInput" tabindex="-1" class="datepicker__input" hide-datepicker="function () { [native code] }">
                                        Mon, Apr 13
                                    </div>
                                </div>
                                <!---->
                                <div class="datepicker datepicker--closed">
                                    <div class="-hide-on-desktop">
                                        <!---->
                                    </div>
                                    <div class="datepicker__inner">
                                        <div class="datepicker__header">
                                            <span tabindex="-1" class="datepicker__month-button datepicker__month-button--prev -hide-up-to-tablet"></span><span tabindex="-1" class="datepicker__month-button datepicker__month-button--next -hide-up-to-tablet"></span>
                                        </div>
                                        <div class="datepicker__months">
                                            <div class="datepicker__month">
                                                <p class="datepicker__month-name">April 2020</p>
                                                <div class="datepicker__week-row -hide-up-to-tablet">
                                                    <div class="datepicker__week-name">Sun</div>
                                                    <div class="datepicker__week-name">Mon</div>
                                                    <div class="datepicker__week-name">Tue</div>
                                                    <div class="datepicker__week-name">Wed</div>
                                                    <div class="datepicker__week-name">Thu</div>
                                                    <div class="datepicker__week-name">Fri</div>
                                                    <div class="datepicker__week-name">Sat</div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            29
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            30
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            31
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--disabled">
                                                            1
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--disabled">
                                                            2
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--disabled">
                                                            3
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--disabled">
                                                            4
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--disabled">
                                                            5
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--first-day-selected" style="border: 1px solid #30b0ff;">
                                                            6
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day  datepicker__month-day--selected">
                                                            7
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day  datepicker__month-day--selected">
                                                            8
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day  datepicker__month-day--selected">
                                                            9
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day  datepicker__month-day--selected">
                                                            10
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day  datepicker__month-day--selected">
                                                            11
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day  datepicker__month-day--selected">
                                                            12
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--last-day-selected">
                                                            13
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            14
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            15
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            16
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            17
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            18
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            19
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            20
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            21
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            22
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            23
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            24
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            25
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            26
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            27
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            28
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            29
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            30
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            1
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            2
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            3
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            4
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            5
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            6
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            7
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            8
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            9
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="datepicker__month">
                                                <p class="datepicker__month-name">May 2020</p>
                                                <div class="datepicker__week-row -hide-up-to-tablet">
                                                    <div class="datepicker__week-name">Sun</div>
                                                    <div class="datepicker__week-name">Mon</div>
                                                    <div class="datepicker__week-name">Tue</div>
                                                    <div class="datepicker__week-name">Wed</div>
                                                    <div class="datepicker__week-name">Thu</div>
                                                    <div class="datepicker__week-name">Fri</div>
                                                    <div class="datepicker__week-name">Sat</div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            26
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            27
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            28
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            29
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            30
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            1
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            2
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            3
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            4
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            5
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            6
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            7
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            8
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            9
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            10
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            11
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            12
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            13
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            14
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            15
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            16
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            17
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            18
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            19
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            20
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            21
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            22
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            23
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            24
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            25
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            26
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            27
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            28
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            29
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            30
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day">
                                                            31
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            1
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            2
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            3
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            4
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            5
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="square">
                                                    <div>
                                                        <!---->
                                                        <div tabindex="-1" class="datepicker__month-day datepicker__month-day--hidden">
                                                            6
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!---->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </date-picker>
                    <p class="text-red-600 text-xs italic mt-1" v-if="errorMessage">
                        {{ errorMessage }}
                    </p>
                </form>
                <div class="col-md-12 action-img">
                    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                </div>
                <div class="col-md-6 action-img">
                    <img src="@imgPath/img/svg/img/succes-img.svg" alt />
                </div>

                <div class="col-md-6 book-details success">
                    <div class="title-main">
                        <span>Your Flight</span>
                        <span>Booking Successful</span>
                    </div>
                    <div class="container-title">Booking Details</div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="content-section">
                                <span>Booking Reservation ID</span>
                                <span>56K89k</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="content-section">
                                <span>PNR</span>
                                <span>CHJDJDJD</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="content-section">
                                <span>Ticketing Deadline</span>
                                <span>25-Mar-2019 19:00</span>
                            </div>
                        </div>
                    </div>
                    <div class="cta-seaction">
                        <button class="general-btn success">Back to Home</button>
                    </div>
                </div>
            </div>
        </section>
        <section class="bk-details">
            <div class="sec-title">Flight Details</div>
            <div class="content">
                <div class="fl-details">
                    <div class="wrapper">
                        <div class="sec-wrapper">
                            <div class="date">Sunday, March 25, 2020 - Depart</div>
                            <div id="flight-result-wrapper">
                                <div class="individual-flight">
                                    <div data-v-0052d509 class="card info-flight">
                                        <div class="main-info-wrap">
                                            <div class="info-wrap">
                                                <div class="time-place-wrap">
                                                    <div class="left">
                                                        <div class="place-code">RGN</div>
                                                        <div class="time">00:00</div>
                                                        <div class="place">Yangon</div>
                                                    </div>
                                                    <div class="center">
                                                        <img src="/img/arrow.cf2a4046.svg" alt />
                                                    </div>
                                                    <div class="right">
                                                        <div class="place-code">MDL</div>
                                                        <div class="time">
                                                            01:25
                                                            <span class="day"></span>
                                                        </div>
                                                        <div class="place">Mandalay</div>
                                                    </div>
                                                </div>
                                                <div class="flight-name">
                                                    <div class="logo">
                                                        <img src="https://a24-b2b.s3-ap-southeast-1.amazonaws.com/mf/logo/airline/svg/st.svg" />
                                                    </div>
                                                    <div class="name">
                                                        <div class="t-flight-name">Air Thanlwin</div>
                                                        <span class="flight-code">ST-827 | Class Q</span>
                                                    </div>
                                                </div>
                                                <div class="luggage d-flex">
                                                    <div class="d-flex mr-auto">
                                                        <img src="@imgPath/img/svg/icons/clock.svg" alt />
                                                        <span>20 h 30 m</span>
                                                    </div>
                                                    <div class="d-flex mr-auto back">
                                                        <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt />
                                                        <span class="back-c">20 Kg</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sec-wrapper">
                            <div class="date">Sunday, March 25, 2020 - Return</div>
                            <div id="flight-result-wrapper">
                                <div class="individual-flight">
                                    <div data-v-0052d509 class="card info-flight">
                                        <div class="main-info-wrap">
                                            <div class="info-wrap">
                                                <div class="time-place-wrap">
                                                    <div class="left">
                                                        <div class="place-code">RGN</div>
                                                        <div class="time">00:00</div>

                                                        <div class="place">Yangon</div>
                                                    </div>
                                                    <div class="center">
                                                        <img src="@imgPath/img/svg/icons/arrow.svg" alt />
                                                    </div>
                                                    <div class="right">
                                                        <div class="place-code">MDL</div>
                                                        <div class="time">
                                                            01:25
                                                            <span class="day"></span>
                                                        </div>
                                                        <div class="place">Mandalay</div>
                                                    </div>
                                                </div>
                                                <div class="flight-name">
                                                    <div class="logo">
                                                        <img src="https://a24-b2b.s3-ap-southeast-1.amazonaws.com/mf/logo/airline/svg/st.svg" />
                                                    </div>
                                                    <div class="name">
                                                        <div class="t-flight-name">Air Thanlwin</div>
                                                        <span class="flight-code">ST-827 | Class Q</span>
                                                    </div>
                                                </div>

                                                <div class="luggage d-flex">
                                                    <div class="d-flex mr-auto">
                                                        <img src="@imgPath/img/svg/icons/clock.svg" alt />
                                                        <span>20 h 30 m</span>
                                                    </div>
                                                    <div class="d-flex mr-auto">
                                                        <img src="/img/Suitcase_icon.b6c12de8.svg" alt />
                                                        <span class="back-c">20 Kg</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ps-details">
                    <div class="sub-t text-center">Passenger Details</div>
                    <div class="pass-details">
                        <div class="img">
                            <img src="@imgPath/img/svg/icons/male.svg" alt />
                        </div>
                        <div class="text">
                            <div class="name">Mr. Leonardo DiCaprio</div>
                            <div class="type">Adult</div>
                        </div>
                    </div>
                    <div class="pass-details">
                        <div class="img">
                            <img src="@imgPath/img/svg/icons/female.svg" alt />
                        </div>
                        <div class="text">
                            <div class="name">Miss. Selena Gomez</div>
                            <div class="type">Adult</div>
                        </div>
                    </div>
                    <div class="pass-details">
                        <div class="img">
                            <img src="@imgPath/img/svg/icons/male.svg" alt />
                        </div>
                        <div class="text">
                            <div class="name">Mr. Harul Belier</div>
                            <div class="type">Adult</div>
                        </div>
                    </div>
                </div>
                <div class="payment-details">
                    <div class="block">
                        <div class="nor">Payment Details</div>
                        <div class="py-mth-logo">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/MasterCard_Logo.svg/1200px-MasterCard_Logo.svg.png" alt />
                        </div>
                    </div>
                    <div class="block">
                        <div class="title">Total Charges</div>
                        <div class="price">MMK 1200,000</div>
                    </div>
                    <div class="block">
                        <div class="title">Fare Breakup</div>
                        <div class="total">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Base Fare</td>
                                        <td>MMK</td>
                                        <td>19099.00</td>
                                    </tr>
                                    <tr>
                                        <td>Taxes & Fees</td>
                                        <td>MMK</td>
                                        <td>19099.00</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>MMK</td>
                                        <td>19099.00</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <cJsonExcelModal v-if="showJsonExcelModal" :show="showJsonExcelModal" :desc="$t('jsonExcelModal.desc', { name: $t('fareUpload.flightFares') })" :onCancel="toggleJsonExcelModal">
        <!-- <template #jsonExcel>
            <div @click="toggleJsonExcelModal()">
                <JsonExcel :data="getTableItems()" :fields="getJsonExcelFields()" worksheet="Statements" :name="'nb_AZ.xls'">{{ $t("fareUpload.download") }}</JsonExcel>
            </div>
        </template> -->
    </cJsonExcelModal>
</div>
</template>

<script>
import cSearch from "../components/search/cSearch";
import {
    mapActions,
    mapGetters
} from "vuex";
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
//Vue.component('date-picker', DatePicker)
import cJsonExcelModal from "../components/modal/cJsonExcelModal";
//import JsonExcel from "vue-json-excel";
import Logger from "../services/logger";
import {
    PATHNAME,
    COMPONENT_NAME,
    DEFAULT_DROPDOWN_STATUS,
    ORDER
} from "../util/constants";
import SERVICE_URL, {
    FILE_NAME,
    LOG_TYPE,
    HTTP_CODES
} from "../config/API_DATA";
import BaseConfiguration from "../config/base.js";
import {

    cloneData
} from "../util/util";
import UploadExcelComponent from '../components/excel/index.vue';

export default {
    components: {
        cSearch,
        DatePicker,
        cJsonExcelModal,
        
        UploadExcelComponent
    },
    data() {
        return {
            showJsonExcelModal: false,

            lsRoutesTableFields: [
     {
    langTest: 'Velkommen til din App',
    language_picker_helper: 'Velg et språk',
    languages: {
        english: 'Engelsk',
        norwegian: 'Norsk',
    },
    agentRegPage: {
        coDetails: "aaaa",
        agencyName: "bbbb",
        busRegNo: "cccc",
        iataNo: "dddd",
        agencyPlace: "eeee",
        optPlace: "ffff"
    },

}


            


            ],
            search: null,
            isShowState: true,
            range: {
                start: new Date(2018, 0, 16), // Jan 16th, 2018
                end: new Date(2018, 0, 19) // Jan 19th, 2018
            },
            tableData:[],
            tableHeader:[]
        }
    },
    computed: {

        errorMessage() {
            if (!this.range.start) return 'Departure Date is required.';
            if (!this.range.end) return 'Return Date is required.';
            return '';
        },
    },
    methods: {
        ...mapActions("sCSearch", {
            SET_SEARCH_OBJ: "SET_SEARCH_OBJ",

        }),

        ...mapActions("sCMultiCitySearch", {
            SET_ML_SEARCH_OBJ: "SET_ML_SEARCH_OBJ",

        }),

         beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$dialog.confirm('<stong>Please do not upload files larger than 1MB in size. </stong><div></div>')                    
                    .then(function (dialog) {
                        //OK handler
                    })
                    .catch(function () {
                        //log
                    });
      
      return false
    },
    formatXLValues(pResults) {
        try {
          if(BaseConfiguration.isDebug) console.log("formatXLValues");
          let retValue={};
          
         for(let i=0;i<pResults.length;i++){
             let pageName=pResults[i]['Page Name']
             let key=[pResults[i]['key']]
             let subkey=pResults[i]['subkey']
             let value=pResults[i]['ca_value']

            if(pResults[i]['Page Name']){
  
                retValue[pageName]={};
                if(pResults[i]['subkey']){
                    if([pResults[i]['key']]){
                   retValue[pageName][key]={}
                    retValue[pageName][key][subkey]=value;
           
                    }else{
                         let addKey={};
                         addKey[subkey]=value;
                          Object.assign(Object.values(retValue[Object.keys(retValue)[Object.keys(retValue).length-1]])[Object.values(retValue[Object.keys(retValue)[Object.keys(retValue).length-1]]).length-1],addKey)
                    }
                   

                }else{
                 retValue[pageName][key] =value;

                }
            }else{
                if(pResults[i]['subkey']){
                  if(pResults[i]['key']){
                 
           let addKey={};
                addKey[key]={};
            addKey[key][subkey]=value;
           Object.assign(retValue[Object.keys(retValue)[Object.keys(retValue).length-1]], addKey)
                    }else{
                         let addKey={};
                addKey[subkey]=value;
                          Object.assign(Object.values(retValue[Object.keys(retValue)[Object.keys(retValue).length-1]])[Object.values(retValue[Object.keys(retValue)[Object.keys(retValue).length-1]]).length-1],addKey)
                    }
                }else{
             let addKey={};
                addKey[key]=value;

           Object.assign(retValue[Object.keys(retValue)[Object.keys(retValue).length-1]], addKey)
                }
              

            }                  

         }
         
        //  console.error(retValue)
    return retValue;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in formatXLValues",
                  err.toString(),
                  "formatXLValues",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
        }, 

         async handleSuccess({ results, header }) {
     try{
                 if(BaseConfiguration.isDebug) console.log("handleSuccess");

      this.tableData = results
      this.tableHeader = header

          let retValue=this.formatXLValues(results);
           this.lsRoutesTableItems=[];
          this.lsRoutesTableItems.push(retValue);
     }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in handleSuccess",
                  err.toString(),
                  "handleSuccess",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
     
    },

        getJsonExcelFields() {
            let retValue;
            try {
                if (BaseConfiguration.isDebug) console.log("getJsonExcelFields");
                let fields = {};

                fields['Page Name'] = "pageName";
                fields['key'] = "key";
                fields['subkey'] = "subkey";

                fields['value'] = "value";

                retValue = cloneData(fields);
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.FARE_UPLOAD_ALL,
                    "error in getJsonExcelFields",
                    err.toString(),
                    "getJsonExcelFields",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
            return retValue;
        },
        toggleJsonExcelModal() {
            try {
                if (BaseConfiguration.isDebug) console.log("toggleJsonExcelModal");

                this.showJsonExcelModal = !this.showJsonExcelModal;
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.FARE_UPLOAD_ALL,
                    "error in toggleJsonExcelModal",
                    err.toString(),
                    "toggleJsonExcelModal",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        getTableItems() {
            let retValue = [];

            for (let i = 0; i < Object.keys(this.lsRoutesTableItems[0]).length; i++) {

                if (typeof Object.values(this.lsRoutesTableItems[0])[i] === 'string' || Object.values(this.lsRoutesTableItems[0])[i] instanceof String) {

                    let obj1 = {
                        pageName: Object.keys(this.lsRoutesTableItems[0])[i],
                        key: Object.keys(this.lsRoutesTableItems[0])[i],
                        subkey: '',
                        value: Object.values(this.lsRoutesTableItems[0])[i]
                    }
                    retValue.push(obj1)

                } else {
                    console.log(Object.keys(this.lsRoutesTableItems[0])[i]);
                    for (let j = 0; j < Object.keys(Object.values(this.lsRoutesTableItems[0])[i]).length; j++) {

                        if (typeof Object.values(Object.values(this.lsRoutesTableItems[0])[i])[j] === 'string' || Object.values(Object.values(this.lsRoutesTableItems[0])[i])[j] instanceof String) {
                            let obj1 = {
                                pageName: (j == 0) ? Object.keys(this.lsRoutesTableItems[0])[i] : '',
                                subkey: '',
                                key: Object.keys(Object.values(this.lsRoutesTableItems[0])[i])[j],
                                value: Object.values(Object.values(this.lsRoutesTableItems[0])[i])[j]
                            }
                            retValue.push(obj1)
                        } else {
                          for (let k = 0; k < Object.keys(Object.values(Object.values(this.lsRoutesTableItems[0])[i])[j]).length; k++) {
                            let obj1 = {
                                      pageName: (j == 0) ? Object.keys(this.lsRoutesTableItems[0])[i] : '',
                                      key: (k == 0) ?Object.keys(Object.values(this.lsRoutesTableItems[0])[i])[j]:'',
                                      subkey: Object.keys(Object.values(Object.values(this.lsRoutesTableItems[0])[i])[j])[k],
                                      value: Object.values(Object.values(Object.values(this.lsRoutesTableItems[0])[i])[j])[k]
                                  }
                                  retValue.push(obj1)
                          }

                        }

                    }

                }
            }

            return retValue;

        },
        //to asign search history to search values
        assignHistoryToSearch(pHstryObj) {
            if (BaseConfiguration.isDebug) console.log("assignHistoryToSearch");
            try {
                if (pHstryObj != null) {
                    this.isShowState = false;
                    let searchObj = this.setValidTravelDate(pHstryObj);
                    this.search = JSON.parse(JSON.stringify(searchObj));
                    let that = this;
                    setTimeout(function () {
                        that.isShowState = true;
                    });
                }
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.SEARCHPAGE,
                    "error in asignHistoryToSearch",
                    err.toString(),
                    "asignHistoryToSearch",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        //to navigate to search result page
        navToResultPage(pSearchObj, isMLSearch) {
            try {
                if (BaseConfiguration.isDebug) console.log("navToResultPage");
                if (pSearchObj) {
                    this.search = pSearchObj;

                    if (isMLSearch) {
                        this.SET_ML_SEARCH_OBJ(this.search)
                        navigate(PATHNAME.ML_FLIGHTRESULTS);
                    } else {
                        this.SET_SEARCH_OBJ(this.search);
                        navigate(PATHNAME.FLIGHTRESULTS);

                    }

                } else {
                    this.showToast(
                        " Invalid search Object",
                        TOAST_TYPE.ERROR,
                        1000,
                        null
                    );
                }
                // if (this.storeSearchHistory(this.search)) {

                //  }
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.SEARCHPAGE,
                    "error while navigation",
                    err.toString(),
                    "navToResultPage",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

        getSearchHistory(pUserId) {
            if (BaseConfiguration.isDebug) console.log("getSearchHistory");
            try {
                let sHistory = [];
                if (pUserId) {
                    let history = JSON.parse(
                        getFlightSearchHisFromLocal(pUserId)
                    );
                    if (history) {
                        sHistory = history
                    }
                }
                return sHistory;
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.SEARCHPAGE,
                    "error in getSearchHistory",
                    err.toString(),
                    "getSearchHistory",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },
        setValidTravelDate(pHistoryObj) {
            try {
                let historyObj = JSON.parse(JSON.stringify(pHistoryObj));
                if (historyObj.route && historyObj.route.length > 0) {
                    if (historyObj.route[0] && historyObj.route[0].date) {
                        if (
                            getDiffBtwDates(
                                new Date(historyObj.route[0].date),
                                new Date(),
                                "days"
                            ) >= 0
                        ) {
                            historyObj.route[0].date = new Date(historyObj.route[0].date);
                        } else {
                            historyObj.route[0].date = new Date();
                        }
                    }
                    if (historyObj.route[1] && historyObj.route[1].date) {
                        if (
                            getDiffBtwDates(
                                new Date(historyObj.route[1].date),
                                new Date(historyObj.route[0].date),
                                "days"
                            ) >= 0
                        ) {
                            historyObj.route[1].date = new Date(historyObj.route[1].date);
                        } else {
                            historyObj.route[1].date = new Date(addDays(new Date(historyObj.route[0].date), 7));
                        }
                    }
                }

                return historyObj;
            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.SEARCHPAGE,
                    "error in setValidTravelDate",
                    err.toString(),
                    "setValidTravelDate",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

    }
}
</script>

<style>
html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed~.c-wrapper,
html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed~.c-wrapper {
    margin: 0px !important;
}

html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right),
html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
    display: none;
}
</style>
